<template>
  <div class="p-l-5 m-b-10">
    <div class="m-b-2 m-t-5">
      <strong>{{ columnDisplayName }}</strong>
    </div>
    <table class="table_beauty condensed-alternate">
      <thead>
        <tr class="bg-transparent">
          <th v-t="'NAME'" />
          <th v-if="columnName.toLowerCase() === 'notacceptedtargets'"  v-t="'REASON'" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedHangupRerouteDetail"
          :key="index"
          class="bg-transparent"
        >
          <td>
            <a
              rel="noopener"
              target="_blank"
              :href="target.url"
              class="table-ellipsis__name linked-name"
            >
              <span>{{ target.name }}</span>
            </a>
          </td>
          <td v-if="columnName.toLowerCase() === 'notacceptedtargets'">
            <span>{{ target.reason ? target.reason : '' }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'TargetHangupRerouteSummary',
  props: {
    targets: {
      type: String,
      default: '',
    },
    columnName: {
      type: String,
      default: '',
    },
    columnDisplayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedHangupRerouteDetail: [],
    };
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parsedHangupRerouteDetail = this.parseTargets(this.getTargetsFromString(newValue));
        }
      },
    },
  },
  methods: {
    parseTargets(targets) {
      const newTargetList = targets.map(target => {

        // remove "/r" from the target
        target = target.replace(/\r/g, '');

        const newTarget = {};

        // Example target from API: "NAME [ID] REASON"
        // regex match anything between two square brackets
        newTarget["id"] = target.match(/\[(.*?)\]/g).map(id => id.replace(/[\[\]']+/g, ''))[0];
        newTarget["name"] = target.split('[')[0];
        newTarget["reason"] = target.split('] ')[1];

        const targetType = newTarget.id.slice(0, 2) === "TA" ? "target" : "ringtreetarget";
        let baseUrl = `#/dashboard/${targetType}/edit/`;

        newTarget["url"] = `${baseUrl}${newTarget.id}`;

        return newTarget;
      });

      return newTargetList
    },
    getTargetsFromString(value) {
      const splitTargetsRegex = /(\[\d+,\s?\d+\],)/gm;
      const splitTargets = value.split('\n');
      const targets = [];
      for (let j = 0; j < splitTargets.length; j++) {
        if (splitTargets[j]) {
          const splitString = splitTargets[j].split(splitTargetsRegex);
          for (let i = 0; i < splitString.length; i += 2) {
            if (splitString[i]) {
              targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
            }
          }
        }
      }
      return targets;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>